// ── Detail DTO ────────────────────────────────────────────────────────────────

export interface ChequeIssuanceDto {
  id:                       string;
  issuanceNumber:           string;
  chequeRecordId:           string;
  issuanceDate:             string;
  issuedByUserId:           string;
  issuedByName:             string;
  collectorName:            string;
  collectorIdType?:         string | null;
  collectorIdNumber?:       string | null;
  collectorPhone?:          string | null;
  collectorRelationship?:   string | null;
  witnessName?:             string | null;
  witnessIdNumber?:         string | null;
  isAcknowledged:           boolean;
  acknowledgedAt?:          string | null;
  signatureReference?:      string | null;
  issuanceStatus:           string;
  collectedAt?:             string | null;
  remarks?:                 string | null;
  cancellationReason?:      string | null;
  createdDate:              string;
}

// ── List row DTO ──────────────────────────────────────────────────────────────

export interface ChequeIssuanceListDto {
  id:                 string;
  issuanceNumber:     string;
  chequeRecordId:     string;
  chequeNumber:       string;
  collectorName:      string;
  collectorIdNumber?: string | null;
  issuanceDate:       string;
  issuanceStatus:     string;
  isAcknowledged:     boolean;
  /** The payment voucher this cheque was written on (GAP-015). */
  referenceDocument?: string | null;
  bankAccountCode?:   string | null;
  bankAccountName?:   string | null;
  payeeName?:         string | null;
  amount?:            number | null;
  currencyCode?:      string | null;
  /** 0 = not yet printed — the "pending print" half of the status view (GAP-015). */
  printCount:         number;
}

// ── Filter DTO ────────────────────────────────────────────────────────────────

export interface ChequeIssuanceFilterDto {
  companyId:          string;
  chequeRecordId?:    string;
  issuanceStatus?:    string;
  issuanceDateFrom?:  string;
  issuanceDateTo?:    string;
  collectorName?:     string;
  /** Cheque number, payee, or payment voucher reference (GAP-015). */
  search?:            string;
  bankAccountId?:     string;
  /** PRINTED or NOT_PRINTED (GAP-015). */
  printStatus?:       string;
  page?:              number;
  pageSize?:          number;
}

// ── Create / action requests ──────────────────────────────────────────────────

export interface CreateChequeIssuanceRequest {
  chequeRecordId:         string;
  issuanceDate?:          string;
  collectorName:          string;
  collectorIdType?:       string;
  collectorIdNumber?:     string;
  collectorPhone?:        string;
  collectorRelationship?: string;
  witnessName?:           string;
  witnessIdNumber?:       string;
  remarks?:               string;
}

export interface AcknowledgeChequeIssuanceRequest {
  signatureReference?: string;
}

export interface CancelChequeIssuanceRequest {
  reason: string;
}

export interface MarkCollectedRequest {
  collectedAt?: string;
}

// ── Status display helpers ────────────────────────────────────────────────────

export const CHEQUE_ISSUANCE_STATUS_COLORS: Record<string, string> = {
  Pending:   'bg-yellow-100 text-yellow-700',
  Issued:    'bg-blue-100 text-blue-700',
  Collected: 'bg-green-100 text-green-700',
  Cancelled: 'bg-red-100 text-red-700',
};

export const CHEQUE_ISSUANCE_STATUS_LABELS: Record<string, string> = {
  Pending:   'Pending',
  Issued:    'Issued',
  Collected: 'Collected',
  Cancelled: 'Cancelled',
};
